import { Component, OnInit, Input, Output, EventEmitter, ViewChild, HostListener, ElementRef } from '@angular/core';
import { QuestionnaireService } from 'src/app/services/questionnaire/questionnaire.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-question-filter',
  templateUrl: './question-filter.component.pug',
  styleUrls: ['./question-filter.component.scss'],
  standalone: false
})
export class QuestionFilterComponent implements OnInit {
  @Input() surveyType = 'exit';
  @Input() isCheckboxFilters = false;
  @Input() isStatusFilters = false;
  @Input() rehireStatusFilters: any[] = [];
  @Input() filterCheckboxTitle = '';
  @Input() filterCheckboxOptions: any[] = [];
  @Input() filterStatusTitle = '';
  @Input() filterStatusOptions: any[] = [];
  @Input() localStorageName = '';
  @Input() filterData: any = {};
  @Output() filterUpdate = new EventEmitter();
  @ViewChild('dateFilter', {static: false}) filterDropdown: any;
  selectedCheckboxFilters = {};
  selectedStatusFilters = {};
  filterEnabled = false;
  filterCount = 0;
  selectedGroup = 'All';
  filterConfig: any;
  result=0;
  allMetrics = {};

  @HostListener('document:click', ['$event'])
  clickout(event){
  }

  constructor(private eRef: ElementRef,
              private questionnaireService: QuestionnaireService,
              private permission: PermissionsService
             ) { }

  ngOnInit(): void {
    if (Object.keys(this.filterData).length > 0) {
      this.presetFilterData();
      this.filterEnabled = true;
    }
    if (this.surveyType!='exit' && this.surveyType!='pulse'){
      this.questionnaireService.getFilterConfig().subscribe(
        res=>{
          this.filterConfig = res;
          let totalQuestions = 0;
          Object.keys(this.filterConfig).forEach((key:any)=>{
            totalQuestions += this.filterConfig[key].total_count;
          });
          let allMetrics = this.filterConfig['personal_attribute'].data.concat(this.filterConfig['role_specific'].data);
          this.filterConfig['All'] = {
            'total_count': totalQuestions,
            'data': allMetrics
          }
          this.result = this.filterConfig['All'].total_count;
          this.presetFilterData();
        }
      )
    }
  }

  presetFilterData() {
    if (this.isCheckboxFilters && this.filterData && this.filterData.checkboxOption) {
      this.filterData.checkboxOption.forEach(f => {
        if (f !== 'all') {
          this.selectedCheckboxFilters[f] = true;
        }
      });
    }
    if (this.isStatusFilters && this.filterData && this.filterData.statusOption) {
      this.filterData.statusOption.forEach(f => {
        this.selectedStatusFilters[f] = true;
      });
    }
    if (this.filterConfig){
      console.log(this.filterConfig);
      this.filterConfig['All']['data'].forEach(m => {
        this.allMetrics[m['mid']] = m;
        this.selectedStatusFilters[m['mid']] = false;
      })
    }
    let statusFiltersActive = Object.values(this.selectedStatusFilters).indexOf(true) > -1;
    let checkboxFiltersActive = Object.values(this.selectedCheckboxFilters).indexOf(true) > -1;
    this.setFilterCount(statusFiltersActive, checkboxFiltersActive)
  }
  onSelectCheckbox(status, event) {
    this.selectedCheckboxFilters[status] = event.target.checked;
    this.calculateNumberOfQuestions();
  }

  private calculateNumberOfQuestions() {
    this.result = 0;
    Object.keys(this.selectedStatusFilters).forEach((filter:any)=>{
      if (this.selectedStatusFilters[filter]){
        if (this.selectedCheckboxFilters['is_verified'] && this.selectedCheckboxFilters['is_measured']){
          this.result += this.allMetrics[filter].count_is_verified_and_measured_count;
        } else if (this.selectedCheckboxFilters['is_verified']) {
          this.result += this.allMetrics[filter].count_is_verified;
        } else if (this.selectedCheckboxFilters['is_measured']) {
          this.result += this.allMetrics[filter].count_is_measured;
        } else {
          this.result += this.allMetrics[filter].count;
        }
      }
    });

    // IF GROUP IS SELECTED
    if (!this.result){
      if (this.selectedCheckboxFilters['is_verified'] && this.selectedCheckboxFilters['is_measured']){
        if (this.selectedGroup === 'All'){
          this.result = 0
          for (var key of Object.keys(this.filterConfig)) {
            if (key !== 'All') this.result += this.filterConfig[key].total_count_is_verified_and_measured_count;
          }
        } else {
          this.result = this.filterConfig[this.selectedGroup].total_count_is_verified_and_measured_count;
        }
      } else if (this.selectedCheckboxFilters['is_verified']) {
        if (this.selectedGroup === 'All'){
          this.result = 0
          for (var key of Object.keys(this.filterConfig)) {
            if (key !== 'All') this.result += this.filterConfig[key].total_count_is_verified;
          }
        } else {
          this.result = this.filterConfig[this.selectedGroup].total_count_is_verified;
        }
      } else if (this.selectedCheckboxFilters['is_measured']) {
        if (this.selectedGroup === 'All'){
          this.result = 0
          for (var key of Object.keys(this.filterConfig)) {
            if (key !== 'All') this.result += this.filterConfig[key].total_count_is_measured;
          }
        } else {
          this.result = this.filterConfig[this.selectedGroup].total_count_is_measured;
        }
      } else {
        this.result = this.filterConfig[this.selectedGroup].total_count;
      }
    }
  }

  onSelectStatus(status) {
    console.log(this.selectedStatusFilters)
    if (this.selectedStatusFilters[status]) {
      this.selectedStatusFilters[status] = false;
    } else {
      this.selectedStatusFilters[status] = true;
    }
  }

  onSelectCategory(category){
    if (this.selectedStatusFilters[category]) {
      this.selectedStatusFilters[category] = false;
    } else {
      this.selectedStatusFilters[category] = true;
    }
    this.calculateNumberOfQuestions();
  }

  onSelectGroup(group){
    this.selectedGroup = group;
    Object.keys(this.selectedStatusFilters).forEach((filter:any)=>{
      this.selectedStatusFilters[filter] = false;
    });
    this.calculateNumberOfQuestions();
  }

  reset() {
    this.selectedCheckboxFilters = {};
    this.selectedStatusFilters = {};
    this.filterEnabled = false;
    this.onSelectGroup('All');
    localStorage.removeItem(this.localStorageName);
  }


  setFilterCount(checkboxActive, statusActive) {
    this.filterCount = 0;
    if (this.isCheckboxFilters && checkboxActive) {
      this.filterCount  += 1;
    }
    if (this.isStatusFilters && statusActive) {
      this.filterCount  += 1;
    }
  }

  update() {
    let statusFiltersActive = Object.values(this.selectedStatusFilters).indexOf(true) > -1;
    let checkboxFiltersActive = Object.values(this.selectedCheckboxFilters).indexOf(true) > -1;
    if (this.isCheckboxFilters && !checkboxFiltersActive &&
      this.isStatusFilters && !statusFiltersActive
    ) {
      this.filterEnabled = false;
      localStorage.removeItem(this.localStorageName);
    } else if (!this.isCheckboxFilters && !this.isStatusFilters) {
      this.filterEnabled = false;
    } else {
      this.filterEnabled = true;
      localStorage.removeItem(this.localStorageName);
    }
    let output = {}
    if (this.isCheckboxFilters && checkboxFiltersActive) {
      output['checkboxOption'] = Object.keys(this.selectedCheckboxFilters).filter(filter=>this.selectedCheckboxFilters[filter]);
    } else {
      output['checkboxOption'] = ['all']
    }
    if (this.isStatusFilters) {
      output['statusOption'] = Object.keys(this.selectedStatusFilters).filter(filter=>this.selectedStatusFilters[filter]);
    }
    if (this.selectedGroup) {
      output['selectedGroup'] = this.selectedGroup;
    }
    if (this.filterEnabled) {
      localStorage.setItem(this.localStorageName, JSON.stringify(output));
    }
    this.setFilterCount(statusFiltersActive, checkboxFiltersActive);
    this.filterUpdate.emit(output);
    this.filterDropdown.hide();
  }
}
